import logo from '../assets/Simple_Logo.png'
import footerBg from "../assets/footerbg.jpg";
import { useUser } from "../context/useUser";
import { Link } from "react-router-dom";

const Footer = () => {
    const { user } = useUser();

    if (!user) return null;

  return (
    <footer className="footer-container">
      <div className="footer-bg">
      <div className="footer-content">
        
        <div className="footer-left">
          <img src={logo} alt="Logo" className="footer-logo" />
          <p className="footer-desc">
            Planiukselta saat helposti kaikki korjausrakentamisen ja energiatehokkuushankkeisiin tarvittavat suunnitelmat. Hoidamme myös projektinjohtotyöt ja työmaa-aikaisen valvonnan.
          </p>
          <div className="footer-socials">
            <a href="https://www.instagram.com/planiusoy/?hl=fi"><i className="fa-brands fa-instagram" /></a>
            <a href="#"><i className="fab fa-twitter" /></a>
            <a href="https://www.linkedin.com/company/planius/"><i className="fab fa-linkedin-in" /></a>
          </div>
        </div>

        <div className="footer-text-container">
          <div className="footer-column">
            <h4>PALVELUT</h4>
            <div className="footer-text">
              <p><a href="https://planius.fi/energiapalvelut/">Energiapalvelut</a></p>
              <p><a href="https://planius.fi/lvi-sahko-ja-automaatiosuunnittelu/">LVI-, sähkö- ja automaatiosuunnittelu</a></p>
              <p><a href="https://planius.fi/linjasaneerauksen-suunnittelu/">Linjasaneerauksen suunnittelu</a></p>
              <p><a href="https://planius.fi/projektinjohto-ja-valvonta/">Projektinjohto ja valvonta</a></p>
            </div>
          </div>
          <div className="footer-column">
            <h4>OSOITE</h4>
            <div className="footer-text">
            <p>Lampettikuja 6, 00750 Helsinki</p>
            <p>Y-tunnus: 2915249-7</p>
            </div>
          </div>
          <div className="footer-column">
            <h4>YHTEYSTIEDOT</h4>
            <div className="footer-text">
            <p>Miika Pitkälä </p>
            <p>+358 45 134 3053</p>
            <p>miika.pitkala@planius.fi</p>
            </div>
          </div>
        </div>
        </div>
        </div>
        
      <div className="footer-bottom">
        <p>© 2025 PLANIUS OY - <a href="#">TIETOSUOJASELOSTE</a></p>
      </div>
    </footer>
  )
}

export default Footer
